import React from 'react';
import { Link } from '@tanstack/react-router';
import { ArrowRight } from 'lucide-react';
import { PleriClient } from '../../client/PleriClient';
import { libraryItems, type LibraryItem } from '../Library/libraryData';

import { useTranslation } from 'react-i18next';

const LIST_ITEM_CLASS =
  'group flex w-full items-center gap-3 rounded-lg pl-0 pr-3 py-2.5 text-left text-sm transition-all hover:bg-gray-50 dark:hover:bg-gray-800 hover:shadow-sm';
const ICON_WRAPPER_CLASS =
  'flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 group-hover:bg-orange-100 group-hover:text-orange-700';

function handleQuickstartClick(item: LibraryItem) {
  PleriClient.updateChatInput({
    prompt: item.prompt,
    autoSubmit: item.autoSubmit,
    metrics: {
      eventLocation: 'sidebar_hover',
      eventName: 'libraryItemClick',
      eventType: item.autoSubmit ? 'autoSubmitQuery' : 'templateUse',
      eventValue: item.id,
      eventDetails: {
        category: item.category,
        title: item.title,
        tags: item.tags,
      },
    },
  });
}

export const QuickstartHoverContent: React.FC = () => {
  const { t } = useTranslation('pleri/chat');
  const { t: tLibrary } = useTranslation('pleri/library');
  const featuredItems = libraryItems(tLibrary).filter((item) => item.featured);
  const topSuggested = featuredItems.slice(0, 3);
  return (
    <div className="w-max max-w-[380px] min-w-[280px]">
      <p className="mb-3 text-sm leading-relaxed text-gray-500 dark:text-gray-400">
        {t('youCanTryAskingMeAnyOf')}
      </p>
      <div className="space-y-0.5">
        {topSuggested.map((item) => (
          <button
            key={item.id}
            type="button"
            onClick={() => handleQuickstartClick(item)}
            className={LIST_ITEM_CLASS}
            data-testid={`quickstart-hover-item-${item.id}`}
          >
            <span className={ICON_WRAPPER_CLASS}>{item.icon}</span>
            <span className="min-w-0 flex-1 truncate font-medium text-gray-900 dark:text-gray-100">
              {item.title}
            </span>
          </button>
        ))}
      </div>
      <div className="mt-3 flex justify-end border-t border-gray-100 pt-3 dark:border-gray-800">
        <Link
          to="/quick-start"
          className="inline-flex items-center gap-1.5 text-sm font-medium text-orange-600 transition-colors hover:text-orange-700"
          data-testid="quickstart-view-all"
        >
          {t('viewAll')}
          <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      </div>
    </div>
  );
};
